import type { ReactNode } from 'react';
import { useAppState } from '../state/AppContext.js';
import { Sidebar } from './Sidebar.js';
import { StatusBadge } from './StatusBadge.js';
import { ApiModeBadge } from './ApiModeBadge.js';
import { CreditsChip } from './CreditsChip.js';
import { ROUTE_TITLES } from '../views/index.js';

export function Layout({ children }: { children: ReactNode }) {
  const { collapsed, route } = useAppState();
  const title = ROUTE_TITLES[route];
  return (
    <div className={'app' + (collapsed ? ' collapsed' : '')}>
      <Sidebar />
      <main className="main">
        <div className="main-card">
          <div className="page-title-row">
            <div className="page-title">{title}</div>
            <div className="title-right">
              <CreditsChip />
              <ApiModeBadge />
              <StatusBadge />
            </div>
          </div>
          <div className="feature-body">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
